
$models.foldertypes = {
	
	getItem : function() { },
	
	getList : function($params, $callback) {
		$models.all.getDataFromAPI('folder_types.json', $params, $callback, 'Unable to retrieve folder types.  You might not have permission to do so.');
	},
	
	getSize : function() { },
	
	setItem : function($id, $formData, $callback) {
		if ($id && (parseInt($id) > 0)) {
			$models.all.getDataFromAPI('folder_types/'+parseInt($id)+'.json', $formData, $callback, 'An error occurred whilst saving the folder type', 'PUT');
		} else {
			$models.all.getDataFromAPI('folder_types.json', $formData, $callback, 'An error occurred whilst saving the folder type', 'POST');
		}
	},
	
	deleteItem : function($id, $callback) {
		$models.all.getDataFromAPI('folder_types/'+parseInt($id)+'.json', '', $callback, 'Cannot delete folder type because it is currently in use.', 'DELETE');
	}
	
};



// WEBPACK FOOTER //
// ./src/js/models/foldertypes.js